import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind("[data-fancybox]", {
    // Your custom options can be added here if needed
});

Fancybox.bind("[data-iframe-modal]", {
  on: {
   "Carousel.ready Carousel.change": () => {
      const slide = Fancybox.getSlide();
      slide.el?.querySelector("iframe").setAttribute('src', slide.el?.querySelector("iframe").getAttribute('data-src'));
    },
    shouldClose: () => {
      const slide = Fancybox.getSlide();
      slide.el?.querySelector("iframe").removeAttribute('src');
    },
  },
});
